import {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../hooks/redux";
import useDebounce from "../../hooks/useDebounce";
import {useField, useFormikContext} from "formik";
import {
    checkAvaliableAccountsForSendingThunk,
} from "../../store/reducers/ActionCreators";

export const CurrencyHelper = (props: any) => {

    useEffect(() => {

        props.accountsList.map((account: any) => {

            if (account.accountMainIban === props.payerAccount) {
                props.setCurrency(account.currency)
            }
        })
    }, [props.accountsList, props.hiddenAccountNumberTo])

    return null
}

export const CheckAvaliableAccountsByPhone = (props: any) => {

    const phoneOfCurrentUser = useAppSelector(state => state.userReducer.user.userData.callPhone)
    const dispatch = useAppDispatch()
    const debouncedValue = useDebounce(props.phone, 1500);

    const [, , helpers] = useField<string>(props.name);
    const {setValue} = helpers;

    const [, , helpersAccNumberTo] = useField<string>(props.accNumberTo);
    const setAccNumberToHelper = helpersAccNumberTo.setValue;

    useEffect(() => {

        if (props.phone === phoneOfCurrentUser) {
            props.setErrorText('The transfer cannot be made due to entered Phone is equal to your own.')
            props.setIsHisOwnRecipientData(true)
            props.setIsButtonDisabled(true)
            return
        }

        setAccNumberToHelper(props.phone)
        if (props.phone !== "" && props.phone !== undefined && props.phone !== null) {
            dispatch(checkAvaliableAccountsForSendingThunk(3, props.token, {
                phone: props.phone,
                currency: props.currency,
                transferType: 'phone'
            })).then((res) => {
                if (res.response && res.response.data.includes("User does not exist")) {
                    props.setIsAvailableAccountExists(false)
                    props.setIsButtonDisabled(true)
                }

                if (res.data.length === 1) {
                    setValue(res.data[0].number)
                    props.setIsButtonDisabled(false)
                } else if (res.data.length === 0) {
                    props.setIsAvailableAccountExists(false)
                    props.setIsButtonDisabled(true)
                } else if (res.data.length >= 1) {
                    props.setIsListOfAccounts(res.data)
                    props.setIsButtonDisabled(false)
                }
            })
        }

    }, [debouncedValue])

    return null
}

export const CheckAvailableAccountsByEmail = (props: any) => {

    const dispatch = useAppDispatch()

    const emailOfCurrentUser = useAppSelector(state => state.userReducer.user.userData.email)

    const debouncedValue = useDebounce(props.email, 1500);
    const [, , helpersHiddenAccountNumber] = useField<string>(props.name);
    const {setValue} = helpersHiddenAccountNumber;

    const [, , helpersAccNumberTo] = useField<string>(props.accNumberTo);
    const setAccNumberToHelper = helpersAccNumberTo.setValue;

    useEffect(() => {

        if (props.email === emailOfCurrentUser) {
            props.setErrorText('The transfer cannot be made due to entered Email is equal to your own.')
            props.setIsHisOwnRecipientData(true)
            props.setIsButtonDisabled(true)
            return
        }

        setAccNumberToHelper(props.email)
        if (props.email !== "" && props.email !== undefined && props.email !== null && props.currency !== '') {
            dispatch(checkAvaliableAccountsForSendingThunk(2, props.token, {
                email: props.email,
                currency: props.currency,
                transferType: 'email'
            })).then((res) => {
                if (res.response && res.response.data.includes("User does not exist")) {
                    props.setIsAvailableAccountExists(false)
                    props.setIsButtonDisabled(true)
                }
                if (res.data.length === 1) {
                    props.setIsButtonDisabled(false)
                    setValue(res.data[0].number)
                //    спросить у лёши, че это такое?)
                    props.setAvailableBeneficiaryAccounts(res.data)
                //    спросить у лёши, че это такое?))
                } else if (res.data.length === 0) {
                    props.setIsAvailableAccountExists(false)
                    props.setIsButtonDisabled(true)
                } else if (res.data.length >= 1) {

                    props.setIsListOfAccounts(res.data)
                    props.setIsButtonDisabled(false)

                    props.setIsButtonDisabled(false)
                }
            })
        }
    }, [debouncedValue])

    return null
}

export const CheckAvaliableAccountByWalletId = (props: any) => {

    const clientIdOfCurrentUser = useAppSelector(state => state.userReducer.user.userData.clientId)

    const dispatch = useAppDispatch()
    const [field, meta, helpers] = useField<string>(props.name);
    const {setValue} = helpers;

    const debouncedValue = useDebounce(props.account, 1500);
    useEffect(() => {

        if (props.account === clientIdOfCurrentUser) {
            props.setErrorText('The transfer cannot be made due to entered Wallet ID is equal to your own.')
            props.setIsHisOwnRecipientData(true)
            props.setIsButtonDisabled(true)
            return
        }

        if (props.account !== ""
            && props.account !== undefined
            && props.account !== null
            && props.currency !== ''
            && props.transferMethod === "Wallet Id") {
            dispatch(checkAvaliableAccountsForSendingThunk(1, props.token, {
                userNumber: props.account,
                currency: props.currency
            })).then((res) => {
                if (res.data) {
                    setValue(res.data[0].number)
                    props.setIsButtonDisabled(false)
                } else {
                    props.setIsAvailableAccountExists(false)
                    props.setIsButtonDisabled(true)
                }
            })
        }
    }, [debouncedValue, props.currency])

    return null
}

export const CheckAvaliableAccountByAccountNumber = (props: any) => {

    const dispatch = useAppDispatch()
    const debouncedValue = useDebounce(props.account, 1500);
    const [field, meta, helpersHiddenAccountNumber] = useField<string>(props.name);
    const {setValue} = helpersHiddenAccountNumber;

    useEffect(() => {

        if (props.account !== ""
            && props.account !== undefined
            && props.account !== null
            && props.currency !== '') {
            dispatch(checkAvaliableAccountsForSendingThunk(1, props.token, {
                userNumber: props.account,
                currency: props.currency
            })).then((res) => {
                if (res.data) {
                    setValue(res.data[0].number)
                    props.setIsButtonDisabled(false)
                } else {
                    props.setIsAvailableAccountExists(false)
                    props.setIsButtonDisabled(true)
                }
            })
        }
    }, [debouncedValue, props.currency])

    return null
}

export const ResetFieldByTransferMethod = (props: any) => {
    const {values} = useFormikContext();
    const [field, meta, helpers] = useField<string>(props.name);
    const {setValue} = helpers;

    useEffect(() => {
        if (props.isCreate) {
            props.handleReset()
            setValue("")
        }

        // @ts-ignore
    }, [values.transferMethod])

    return null
}
